module.exports = __webpack_public_path__ + "img/uber.cc790c2b.png";